import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../util/types";

export const questionWrapper = (theme: ThemeV2): SxProps => ({
  width: "1200px",
  maxWidth: "90%",
  padding: `${theme.tokens.spacing["5"]}px ${theme.tokens.spacing["4"]}px`,
  border: `1px solid ${theme.tokens.color.action.primary}`,
  borderRadius: `${theme.tokens.shape.radius.lg}px`,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: theme.tokens.color.surface.card,

  "& > div": { flex: "1 1 auto" },
});

export const textWrapper = (color: string): SxProps => ({
  flex: 1,
  color,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  padding: 2,
  "& > div": {
    width: "100%",
  },
  "& > div > span, & > div > div > span": {
    width: "100%",
    justifyContent: "center",
  },
});

export const actionBtnMaxDiff: SxProps = {
  minHeight: "10vh",
  maxHeight: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  alignItems: "end",
  marginRight: 2,
};

export const dontKnowBtn: SxProps = {
  position: "absolute",
  bottom: 0,
  left: 0,
};

export const subMainWrapper: SxProps = {
  minHeight: "80vh",
  maxHeight: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};
